import React, { Component, ComponentProps } from 'react'

import authService, { LogicalStrategy } from '../../services/auth'
import Redirect from '../redirect'
import { UserType } from '../../application/domain/utils/user.type'
import { VerifyUserType } from '../verify/user.type'
import { VerifyScopes } from '../verify/scopes'
import { AccessToken } from '../../application/domain/models/auth/access.token'

interface IProps extends ComponentProps<any> {
    readonly privateRouter: boolean
    readonly scopes?: string[]
    readonly types?: UserType[]
    readonly logicalStrategy?: LogicalStrategy
}


class ProtectRouterComponent extends Component<IProps> {
    public render() {
        const { children,
            scopes,
            types,
            logicalStrategy,
            privateRouter
        } = this.props

        const authenticate = authService.isAuthenticated()

        if (privateRouter && !authenticate) {
            return <Redirect to="/login"/>
        }

        if (authenticate) {
            const token: AccessToken = authService.decodeToken()
            if (token.email && !token.tfa && !token.protected) {
                if (token.scope) {
                    return <Redirect to="/login/first"/>
                }
                return <Redirect to="/login/tfa/setup"/>
            }

            if (token.email && token.tfa && !token.protected) {
                return <Redirect to="/login/tfa"/>
            }

            if (scopes) {
                try {
                    if (!VerifyScopes.validate(scopes, logicalStrategy)) {
                        throw new Error('ACCESS DENIED')
                    }
                } catch (e) {
                    return <Redirect to="/access_denied"/>
                }
            }
            /* Make sure the user has the necessary type */
            if (types) {
                try {
                    if (!VerifyUserType.validate(types)) {
                        throw new Error('ACCESS DENIED')
                    }
                } catch (e) {
                    return <Redirect to="/access_denied"/>
                }
            }
            return children

        }
    }
}

const ProtectRouter: any = ProtectRouterComponent

export default ProtectRouter
